<template>
  <window-content v-if="!loading && !success && !errors">
    <div class="m-t">
      <e-row class="erp-row-col-md">
        <e-col style="max-width: 240px">
          <erp-s-field
              view="lr"
              label="ID:"
              label-width="110px"
          >
            <erp-input simple-border v-model="comarca.id" disable />
          </erp-s-field>
        </e-col>
      </e-row>
      <e-row>

        <e-col style="max-width: 300px">
          <erp-s-field
              view="lr"
              label="Nome:"
              label-width="110px"
          >
            <erp-input simple-border v-model="comarca.nome" required />
          </erp-s-field>
        </e-col>
      </e-row>
      <e-row>
        <e-col style="max-width: 300px">
          <erp-s-field
              view="lr"
              label="Código:"
              label-width="110px"
          >
            <erp-input simple-border v-model="comarca.codigo" required />
          </erp-s-field>
        </e-col>
      </e-row>
      <e-row>
        <e-col style="max-width: 300px">
          <uf-select label-width="110px" field-view="lr" label="UF:" v-model="comarca.uf" required />
        </e-col>
      </e-row>
      <e-row>
        <e-col class="m-b-sm" style="max-width: 355px;">
          <erp-s-field
              class="font-10 m-r-md"
              view="lr"
              label="Tribunal:"
              label-width="110px"
          >
            <tribunal-input v-model="idTribunal" @selecionaTribunal="confirmarAdicionarTribunal($event)" :set-tribunal="comarca.tribunal" />
          </erp-s-field>
        </e-col>
      </e-row>
    </div>

    <window-footer class="flex content-between">
      <div class="inline-block window-actions text-right self-end col-grow">
        <u-btn label="Cancelar" icon="chevron-left" icon-type="fa" icon-style="light" flat no-caps
               @click="$uloc.window.close($root.wid)" />
        <u-btn label="Salvar (F2)" icon="save" icon-type="fa" icon-style="light" flat no-caps
               @click="save"
               v-shortkey="['f2']" @shortkey.native="save" />
      </div>
    </window-footer>
  </window-content>
  <window-success v-else-if="success">
    <slot name="success">
      <div class="text-center">
        <u-icon name="check-circle" color="positive" type="fa" icon-style="solid" class="success-circle-140" />
      </div>
      <h5 class="m-t" v-if="id"> Atualizado com sucesso!</h5>
      <h5 class="m-t" v-else>Registrado com sucesso!</h5>
      <div class="text-center m-t">
        <timer-close-window ref="timer" @end="$uloc.window.close($root.wid)" />
      </div>
    </slot>
  </window-success>
  <window-loading :errors="errors" :status="status" v-else></window-loading>
</template>

<script>
import {
  WindowContent,
  WindowFooter,
  ErpSField,
  ErpInput
} from 'uloc-vue-plugin-erp'
import WindowLoading from "../../../../layout/window/Loading";
import ERow from "../../../../layout/components/Row";
import ECol from "../../../../layout/components/Col";
import UfSelect from "../../../../remocao/components/include/UfSelect";
import {newComarca, updateComarca, find} from "../../../../../domain/processos/services/comarca";
import TribunalInput from '../../tribunais/input/TribunalInput'
import WindowSuccess from "../../../../layout/window/Success";
import TimerCloseWindow from "../../../../layout/window/TimerClose";

export default {
  name: 'ComarcaWindow',
  props: ['id'],
  components: {
    TimerCloseWindow,
    WindowSuccess,
    UfSelect,
    WindowContent,
    WindowFooter,
    ErpSField,
    ErpInput,
    ERow,
    ECol,
    WindowLoading,
    TribunalInput
  },
  data () {
    return {
      comarca: {
        id: null,
        nome: null,
        codigo: null,
        uf: null
      },
      loading: !!this.id,
      errors: null,
      status: null,
      success: null,
      idTribunal: null
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    load () {
      this.id && find(this.id)
          .then(response => {
            this.comarca = response.data
            this.$nextTick(() => {
              this.loading = false
            })
          })
          .catch((error) => {
            this.$uloc.dialog({
              title: 'Falha ao carregar!',
              color: 'negative',
              message: `Não conseguimos carregar os dados da comarca, entre em contato com o administrador.`
            })
            this.loading = false
            this.errors = error.data
            console.error(error, error.data)
          })
    },
    save () {
      this.loading = true
      this.status = 'Processando comarca'
      const data = {...this.comarca}
      if (data.tribunal?.id) {
        data.tribunal = data.tribunal.id
      }
      const method = data.id ? updateComarca(data.id, data) : newComarca(data)
      method
          .then(({data}) => {
            this.comarca.id = data.id
            this.success = true
            this.$nextTick(() => {
              // this.$refs.timer.start()
              window.setTimeout(() => {
                this.loading = false
                this.success = false
                this.load()
              }, 3000)
              this.$uloc.window.emit(this.$root.wid, 'update', this.props)
            })
          })
          .catch(error => {
            console.log(error)
            this.success = false
            this.errorMessage = error.data.message
            // this.errors = this.systemError(error)
            this.$nextTick(() => {
              this.loading = false
              this.alertApiError(error)
              // this.error = true
            })
          })
    },
    confirmarAdicionarTribunal (evt) {
      if (!evt) return
      this.$uloc.dialog({
        title: 'Atenção',
        message: `Tem certeza que deseja vincular ao tribunal ${evt.nome}?`,
        cancel: true,
        color: 'secondary'
      }).then(data => {
        this.comarca.tribunal = {...evt}
      }).catch(() => {})
    }
  }
}
</script>
